module.exports = __webpack_public_path__ + "static/media/reformer4.c9a8df8e.jpg";